import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-encuesta-matriz',
  templateUrl: './encuesta-matriz.component.html',
  styleUrls: ['./encuesta-matriz.component.css']
})
export class EncuestaMatrizComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsFicha: DataTables.Settings = {};
  public dtTriggerFicha: Subject<any>;

  public encabezado: string = ""; public nombreBeca: string = ""; public selectPeriodo: string = ''; public selectFacultad: string = '';
  public vecListaResponde = []; public vecPeriodo = []; vecFacultad = []; vecPais = []; vecCiudad = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private modalService: NgbModal, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.dtTriggerFicha = new Subject<any>();
    this.dtOptionsFicha[0] = this.tools.OpcionesTabla(10);

    this.encabezado = "Lista de estudiantes postulantes";
    this.nombreBeca = localStorage.getItem('modNom');
    this.cargarPeriodos(); this.cargarFacultades(); this.verProcedencias();
  }
  //FUNCION QUE CARGA TODAS LOS PERIODOS ACADEMICOS DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.selectPeriodo = res.carrera[0]['strCodigo'];
      for (let i in res.carrera) {
        this.vecPeriodo.push({
          codigo: res.carrera[i]['strCodigo'], descripcion: res.carrera[i]['strDescripcion'], inicio: res.carrera[i]['dtFechaInic'], fin: res.carrera[i]['dtFechaFin']
        });
      }
    }
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarFacultades() {
    this.vecFacultad = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.selectFacultad = res.carrera[0]['strCodigo'];
      this.vecFacultad = res.carrera;
    }
  }
  //CARGAR PAISES, PROVINCIAS, CANTONES Y PARROQUIAS
  async verProcedencias() {
    this.vecPais = []; this.vecCiudad = [];
    //VER PAISES
    const resPais = await new Promise<any>(resolve => this.srvSelect.medicoverProvincia(5, 'na', 'na').subscribe(translated => {
      resolve(translated)
    }));
    if (resPais.success)
      this.vecPais = resPais.ciudad;
    //VER PROVINCIAS
    const resProv = await new Promise<any>(resolve => this.srvSelect.medicoverProvincia(1, 'na', 'na').subscribe(translated => {
      resolve(translated)
    }));
    if (resProv.success)
      this.vecCiudad = resProv.ciudad;
  }
  //ABRIR EL MODAL PARA ESCOGER EL PERIODO DE DE CONSULTA
  verFechasRespuesta(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //BUSCAR LAS FICHAS RESPONDIDAS EN EL PERIODO ACADEMICO
  async verResultados() {
    this.vecListaResponde=[];
    let vecAux = [];
    var table2 = $('#tblFichas').DataTable({
      destroy: true
    });
    table2.destroy();
    this.cerrarModal();
    this.cargando.abrir();
    this.vecListaResponde = [];

    const resFicha = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(27, this.selectPeriodo, '1', '1', this.selectFacultad).subscribe(translated => {
        resolve(translated)
      }));
    if (resFicha.success) {

      const resOpciones = await new Promise<any>(resolve =>
        this.srvSelect.gestionEncuesta(271, this.selectPeriodo, '1', '1', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resOpciones.success) {

        const resOtros = await new Promise<any>(resolve =>
          this.srvSelect.gestionEncuesta(272, this.selectPeriodo, '1', 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));

        for (let objResp of resFicha.encuesta) {
          vecAux = resOpciones.encuesta.filter(item => item.intIdResponde == objResp.intIdResponde);

          if (vecAux.length > 0) {

            this.vecListaResponde.push({
              cedula: objResp.strCedEstudiante,
              nombres: vecAux.filter(item => item.intIdOpcion == 1).length > 0 ? vecAux.filter(item => item.intIdOpcion == 1)[0]['strRespuesta'] : '',
              fnacimiento: vecAux.filter(item => item.intIdOpcion == 2).length > 0 ? vecAux.filter(item => item.intIdOpcion == 2)[0]['strRespuesta'] : '',
              provincia: vecAux.filter(item => item.intIdOpcion == 7).length > 0 ? vecAux.filter(item => item.intIdOpcion == 7)[0]['strRespuesta'] : '',
              canton: vecAux.filter(item => item.intIdOpcion == 8).length > 0 ? vecAux.filter(item => item.intIdOpcion == 8)[0]['strRespuesta'] : '',
              parroquia: vecAux.filter(item => item.intIdOpcion == 9).length > 0 ? vecAux.filter(item => item.intIdOpcion == 9)[0]['strRespuesta'] : '',
              sexo: vecAux.filter(item => item.intIdOpcion == 11).length > 0 ? vecAux.filter(item => item.intIdOpcion == 11)[0]['strRespuesta'] : '',
              telefono: vecAux.filter(item => item.intIdOpcion == 33).length > 0 ? vecAux.filter(item => item.intIdOpcion == 33)[0]['strRespuesta'] : '',
              correo: vecAux.filter(item => item.intIdOpcion == 12).length > 0 ? vecAux.filter(item => item.intIdOpcion == 12)[0]['strRespuesta'] : '',
              etnia: vecAux.filter(item => item.intIdPregunta == 38).length > 0 ? vecAux.filter(item => item.intIdPregunta == 38)[0]['strNombre'] : '',
              nacionalidad: vecAux.filter(item => item.intIdOpcion == 232).length > 0 ?
                this.vecPais.filter(iPais => iPais.idPais == vecAux.filter(item => item.intIdOpcion == 232)[0]['strRespuesta']).length > 0 ?
                  this.vecPais.filter(iPais => iPais.idPais == vecAux.filter(item => item.intIdOpcion == 232)[0]['strRespuesta'])[0]['nombre'] : '' : '',
              discapacidad: vecAux.filter(item => item.intIdPregunta == 39).length > 0 ? vecAux.filter(item => item.intIdPregunta == 39)[0]['strNombre'] == 'true' ? 'SI' : 'NO' : 'NO',
              facultad: vecAux.filter(item => item.intIdOpcion == 63).length > 0 ? vecAux.filter(item => item.intIdOpcion == 63)[0]['strRespuesta'] : '',
              carrera: vecAux.filter(item => item.intIdOpcion == 64).length > 0 ? vecAux.filter(item => item.intIdOpcion == 64)[0]['strRespuesta'] : '',
              estCivil: vecAux.filter(item => item.intIdPregunta == 14).length > 0 ? vecAux.filter(item => item.intIdPregunta == 14)[0]['strNombre'] : '',
              nivel: vecAux.filter(item => item.intIdOpcion == 65).length > 0 ? vecAux.filter(item => item.intIdOpcion == 65)[0]['strRespuesta'] : '',
              matricula: '--',
              hijos: resOtros.success ?
                resOtros.encuesta.filter(item => item.intIdResponde == objResp.intIdResponde && item.intIdOtro == 65 && item.otrosRespuesta != '' && item.otrosRespuesta != 'null' && item.otrosRespuesta != '0').length > 0 ? 'SI' : 'NO' : 'NO',

              colegio: vecAux.filter(item => item.intIdOpcion == 80).length > 0 ? vecAux.filter(item => item.intIdOpcion == 80)[0]['strRespuesta'].split(' ')[1] : '',

              dv1: vecAux.filter(item => item.intIdPregunta == 57).length > 0 ? vecAux.filter(item => item.intIdPregunta == 57)[0]['strNombre'] : '',
              dv2: vecAux.filter(item => item.intIdPregunta == 58).length > 0 ? vecAux.filter(item => item.intIdPregunta == 58)[0]['strNombre'] : '',
              dv3: vecAux.filter(item => item.intIdPregunta == 59).length > 0 ? vecAux.filter(item => item.intIdPregunta == 59)[0]['strNombre'] : '',
              dv4: vecAux.filter(item => item.intIdPregunta == 60).length > 0 ? vecAux.filter(item => item.intIdPregunta == 60)[0]['strNombre'] : '',
              dv5: vecAux.filter(item => item.intIdPregunta == 61).length > 0 ? vecAux.filter(item => item.intIdPregunta == 61)[0]['strNombre'] : '',

              dt1: vecAux.filter(item => item.intIdPregunta == 62).length > 0 ? vecAux.filter(item => item.intIdPregunta == 62)[0]['strNombre'] : '',
              dt2: vecAux.filter(item => item.intIdPregunta == 63).length > 0 ? vecAux.filter(item => item.intIdPregunta == 63)[0]['strNombre'] : '',
              dt3: vecAux.filter(item => item.intIdPregunta == 64).length > 0 ? vecAux.filter(item => item.intIdPregunta == 64)[0]['strNombre'] : '',
              dt4: vecAux.filter(item => item.intIdPregunta == 65).length > 0 ? vecAux.filter(item => item.intIdPregunta == 65)[0]['strNombre'] : '',

              db1: vecAux.filter(item => item.intIdPregunta == 66).length > 0 ? vecAux.filter(item => item.intIdPregunta == 66)[0]['strNombre'] : '',
              db2: vecAux.filter(item => item.intIdPregunta == 67).length > 0 ? vecAux.filter(item => item.intIdPregunta == 67)[0]['strNombre'] : '',
              db3: vecAux.filter(item => item.intIdPregunta == 68).length > 0 ? vecAux.filter(item => item.intIdPregunta == 68)[0]['strNombre'] : '',
              db4: vecAux.filter(item => item.intIdPregunta == 69).length > 0 ? vecAux.filter(item => item.intIdPregunta == 69)[0]['strNombre'] : '',
              db5: vecAux.filter(item => item.intIdPregunta == 70).length > 0 ? vecAux.filter(item => item.intIdPregunta == 70)[0]['strNombre'] : '',
              db6: vecAux.filter(item => item.intIdPregunta == 71).length > 0 ? vecAux.filter(item => item.intIdPregunta == 71)[0]['strNombre'] : '',
              db7: vecAux.filter(item => item.intIdPregunta == 72).length > 0 ? vecAux.filter(item => item.intIdPregunta == 72)[0]['strNombre'] : '',

              dc1: vecAux.filter(item => item.intIdPregunta == 73).length > 0 ? vecAux.filter(item => item.intIdPregunta == 73)[0]['strNombre'] : '',
              dc2: vecAux.filter(item => item.intIdPregunta == 74).length > 0 ? vecAux.filter(item => item.intIdPregunta == 74)[0]['strNombre'] : '',
              dc3: vecAux.filter(item => item.intIdPregunta == 75).length > 0 ? vecAux.filter(item => item.intIdPregunta == 75)[0]['strNombre'] : '',
              dc4: vecAux.filter(item => item.intIdPregunta == 76).length > 0 ? vecAux.filter(item => item.intIdPregunta == 76)[0]['strNombre'] : '',
              dc5: vecAux.filter(item => item.intIdPregunta == 77).length > 0 ? vecAux.filter(item => item.intIdPregunta == 77)[0]['strNombre'] : '',

              ded1: vecAux.filter(item => item.intIdPregunta == 78).length > 0 ? vecAux.filter(item => item.intIdPregunta == 78)[0]['strNombre'] : '',
              dec1: vecAux.filter(item => item.intIdPregunta == 79).length > 0 ? vecAux.filter(item => item.intIdPregunta == 79)[0]['strNombre'] : '',
              dec2: vecAux.filter(item => item.intIdPregunta == 80).length > 0 ? vecAux.filter(item => item.intIdPregunta == 80)[0]['strNombre'] : '',
              dec3: vecAux.filter(item => item.intIdPregunta == 81).length > 0 ? vecAux.filter(item => item.intIdPregunta == 81)[0]['strNombre'] : '',

              ingreso: vecAux.filter(item => item.intIdOpcion == 198).length > 0 ? vecAux.filter(item => item.intIdOpcion == 198)[0]['strRespuesta'] : '',
              numFamilia: vecAux.filter(item => item.intIdOpcion == 199).length > 0 ? vecAux.filter(item => item.intIdOpcion == 199)[0]['strRespuesta'] : '',
              area: vecAux.filter(item => item.intIdOpcion == 200).length > 0 ? vecAux.filter(item => item.intIdOpcion == 200)[0]['strRespuesta'] : '',
            });
          }
        }
      }
    }

    this.dtTriggerFicha.next();
    this.cargando.cerrar();
  }
  //FUNCION PARA CERRAR UN MODAL
  cerrarModal() {
    this.mr.close();
  }
}
